// Airway pagers, coverage and codes at THI / BSLMC.

/** Hospital extensions are five digits; from outside, prefix them with this */
export const OUTSIDE_PREFIX = '832-35';
export const DIALING = 'Extensions are five digits. From outside the hospital, dial 832-35 and then the extension.';

/** Pager numbers are extensions you call to page */
export const PAGERS = [
  { id: 'cv', service: 'CV Anesthesiology', ext: '2-6014', covers: 'All ICUs and the Cath Lab' },
  { id: 'main', service: 'Main OR Anesthesiology', ext: '2-6486', covers: 'Floors, ED, CT and MRI, IR, lobby, everywhere else' },
];

export const COVERAGE = [
  { when: '7a–7p', who: 'Each service holds its own pager' },
  { when: '7p–7a', who: 'CV Anesthesiology holds both. It is the only service with in-house call' },
  { when: 'Weekends', who: 'CV Anesthesiology holds both' },
];

export const HANDOFF = [
  'Hand a pager off in person',
  'The Main OR pager is kept in the Anesthesiology office in the Main ORs',
];

/** When a Main OR page comes to the CV pager: a block patient, an add-on */
export const MAIN_OR_CONTACT = {
  intro: 'While the CV service holds the Main OR pager, pages intended for the Main OR anesthesiologist should be redirected to them. Direct the caller, or contact them yourself, by either route below.',
  options: [
    { label: 'TigerConnect', detail: 'BSLMC Anes CHARGE' },
    { label: 'Main OR front desk', detail: 'Ask who is on call', ext: '5-2116' },
  ],
};

export const AIRWAY_CALL = {
  epic: 'Document the airway as an Out-of-OR encounter in Epic',
  resourcesPending: 'Airway equipment and drugs available on each unit: coming',
};

export const CODES = [
  'Anesthesia is there for the airway. Anything more only if asked',
  'RT or the RN usually gathers the equipment',
];

/** From a five-digit extension like "2-6014" to a dialable outside number */
export const outsideNumber = (ext) => `${OUTSIDE_PREFIX}${ext.replace(/\D/g, '')}`;
